// src/admin/pages/PagesAdmin.jsx

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../utils/axios";
import PageCreateForm from "./PageCreateForm";

function PagesAdmin() {
  const [pages, setPages] = useState([]);
  const [showCreatePage, setShowCreatePage] = useState(false);

  const loadPages = () => {
    api.get("/pages").then(res => {
      console.log(res.data);
      setPages(res.data.data)
    });
  };

  useEffect(() => {
    loadPages();
  }, []);

  const deletePage = async (id) => {
    if (!window.confirm("Delete this page?")) return;
    await api.delete(`/api/pages/${id}`);
    loadPages();
  };

  return (
      <div>
        <h2>Pages</h2>

        <button onClick={() => setShowCreatePage((prev) => !prev)}>
          {showCreatePage ? "Cancel" : "+ Add Page"}
        </button>

        {showCreatePage && (
            <PageCreateForm
                onCreated={() => {
                  loadPages();
                  setShowCreatePage(false);
                }}
            />
        )}
        
      <br />
      <ul>
        {pages.map(page => (
            <li className="list-row">
              <span className="list-text">
                <Link to={`/admin/pages/${page.id}`}>
                  {page.title || "(no title)"}
                </Link>
              </span>

              <button style={{marginLeft:"20px"}} className={"button"} onClick={() => deletePage(page.id)}>
                Delete
              </button>
            </li>
        ))}
      </ul>
    </div>
  );
}

export default PagesAdmin;